import React from 'react';
import { Table, Button, Row, Col } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

export default function ModuleList({ modules, onAdd, loading }) {
  const columns = [
    { title: 'Module Name', dataIndex: 'name', key: 'name' },
    { title: 'Description', dataIndex: 'description', key: 'description' },
  ];

  return (
    <>
      <Row justify="end">
        <Col>
          <Button type="primary" onClick={onAdd} icon={<PlusOutlined />} className='mb-16'>
            ADD
          </Button>
        </Col>
      </Row>
      <Table
        rowKey="id"
        columns={columns}
        dataSource={modules}
        loading={loading}
        scroll={{ x: 'max-content' }}
        pagination={false}
      />
    </>
  );
}
